export enum QUERY_KEYS {
  getOfferChannelsById = 'offer-channels-by-id',
}
